interface Country {
    name: string;
    id: number;
}

export const CANADA: Country = {
    name: 'Canada',
    id: 37,
};

export const USA: Country = {
    name: 'United States',
    id: 237,
};
